const en = {
    views: {
        home: {
            men: 'Men',
            women: 'Women',
            users: 'Users',
            table: 'Table',
            usersTotal: 'Total Users:',
            name: 'Name',
            email: 'Email',
        },
    },
};

export default en;
